import React, { Component } from 'react';

import PlaidAuth from './Auth';
import BankService from '../../../Service/BankService';
import { logPageView } from '../../../AppUtil/analytics';
import { hot } from 'react-hot-loader';

class AddAccount extends Component {
	handleOnSuccess = async (token, metadata, isProcessNotRequired) => {
		if (isProcessNotRequired) {
			this.props.OnClose();
			return;
		}
		const fundingSource = {
			public_token: token,
			account_id: metadata.account_id,
			type: metadata.account.subtype,
			institution_name: metadata.institution.name,
			mask: metadata.account.mask
		};
		const response = await BankService.add(fundingSource);
		logPageView('/app/add-funding-source'); // NOSONAR
		this.props.OnClose(response);
	};

	render() {
		return (
			<PlaidAuth OnExit={this.props.OnExit} OnLoad={this.props.OnStart} OnSuccess={this.handleOnSuccess}>
				{this.props.children}
			</PlaidAuth>
		);
	}
}

export default hot(module)(AddAccount);
